import ReactECharts from 'echarts-for-react'
export const HitRateChart = (props: { deptData: { dept_name: string; rate: number }[] }) => {
  const { deptData } = props
  const option = {
    xAxis: {
      max: 100,
      type: 'value',
      // name: '次',
      nameTextStyle: {
        fontWeight: 'bold',
        verticalAlign: 'top',
        lineHeight: 26,
      },
      axisTick: {
        // X轴不要刻度线
        show: false,
      },
      position: 'top',
    },
    grid: {
      left: '10',
      right: '30',
      top: '20',
      bottom: '0',
      containLabel: true,
    },
    yAxis: {
      axisTick: {
        show: false,
      },
      type: 'category',
      data: deptData?.map(item => item.dept_name) || [],
      reverse: true,
      inverse: true,
    },
    series: [
      {
        data: deptData?.map(item => item.rate || 0) || [],
        type: 'bar',
        barWidth: 28,
        barCategoryGap: 20,
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(180, 180, 180, 0.2)',
        },
        label: {
          show: true,
          position: 'left',
          offset: [40, 0],
          color: '#000',
          formatter: e => {
            const score = e.value
            return `${score}%`
            // if (score >= '80') {
            //   return `${score}/优秀`
            // } else if (score >= 60) {
            //   return `${score}/良好`
            // } else if (score >= 40) {
            //   return `${score}/较差`
            // } else if (score < 40) {
            //   return `${score}/差`
            // }
          },
        },
        itemStyle: {
          normal: {
            color: '#558492',
            // color: function (params) {
            //   if (params.value >= 80) {
            //     return '#7FB563'
            //   } else if (params.value >= 60) {
            //     return '#739DFF'
            //   } else if (params.value >= 40) {
            //     return '#FFB035'
            //   } else if (params.value < 40) {
            //     return '#FF5151'
            //   }
            // },
            borderRadius: [0, 8, 8, 0],
          },
        },
      },
    ],
  }
  return <ReactECharts option={option} style={{ height: 40 + deptData?.length * 50 }} />
}
